
import Player from '@/utils/game/Player';
import { Options, Vue } from 'vue-class-component';

@Options({

  data: () => ({
    allTime: [],
    lastLevel: []
  }),

  beforeMount() {
    this.allTime = this.$store.state.gameState.players
      .sort((p1: Player, p2: Player) => {
        return p2.allPoints - p1.allPoints
      })
      .map((p: Player) => {
        return {name: p.name, points: p.allPoints}
      });

    this.lastLevel = this.$store.state.gameState.players
      .sort((p1: Player, p2: Player) => p2.lastPoints - p1.lastPoints)
      .filter((p: Player) => p.lastPoints > 0)
      .map((p: Player) => ({name: p.name, points: p.lastPoints}));
  },
})
export default class PlayersTable extends Vue {}
